import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { FileSelector } from '@carvana/purchase-helpers';
import { CarvanaButton } from '@carvana/purchase-styles';
import DocumentStatusIcon from './components/document-status-icon';
import * as sc from './verification-document.styles';

const VerificationDocument = props => {
  const {
    fileSelector,
    title,
    subtitle,
    details,
    status,
    showUpload,
    showEdit,
    showView,
    wholeDocClick,
    buttonText,
    isLoading,
    isPointerDisabled,
    leftChildren,
    documentType,
    uploadFunction,
    editFunction,
    viewFunction
  } = props;

  const [expanded, setExpanded] = useState(false);

  const isGreyedOut =
    !showUpload &&
    status?.toLowerCase() !== 'complete' &&
    documentType?.toLowerCase() !== 'paystubs';

  const UploadButton = fileSelector.enabled ? FileSelector : CarvanaButton;

  return (
    <sc.TypeWrapper
      style={{ cursor: isPointerDisabled ? 'default' : 'pointer' }}
      onClick={wholeDocClick}
    >
      <sc.ContentWrapper>
        <sc.LeftContent {...props}>
          <sc.IconWrapper>
            <DocumentStatusIcon status={status} />
          </sc.IconWrapper>
          <sc.TypeContent>
            <sc.TypeTitle isGreyedOut={isGreyedOut}>{title}</sc.TypeTitle>
            <sc.TypeSubtitle>{subtitle}</sc.TypeSubtitle>
            {leftChildren}
          </sc.TypeContent>
        </sc.LeftContent>

        <sc.RightContent>
          {showUpload && (
            <UploadButton
              buttonStyles={sc.buttonStyles}
              ghost
              handleSelectedFile={fileSelector.handleSelectedFile}
              onClick={uploadFunction}
              uppercase
              isLoading={isLoading}
              {...props}
            >
              {buttonText || 'Upload'}
            </UploadButton>
          )}

          {showEdit && (
            <sc.RightContentItem onClick={editFunction}>
              {buttonText || 'View & Edit'}
            </sc.RightContentItem>
          )}

          {showView && (
            <sc.RightContentItem onClick={viewFunction}>
              {buttonText || 'View'}
            </sc.RightContentItem>
          )}

          {details && (
            <sc.ExpandArrow
              expanded={expanded ? 'true' : undefined}
              onClick={() => setExpanded(!expanded)}
            />
          )}
        </sc.RightContent>
      </sc.ContentWrapper>

      {details && expanded && (
        <sc.DetailsWrapper>
          <sc.LeftContent>
            <sc.TypeContent>
              <sc.Details>
                {details.map(detail => {
                  return <li key={detail}>{detail}</li>;
                })}
              </sc.Details>
            </sc.TypeContent>
          </sc.LeftContent>
        </sc.DetailsWrapper>
      )}
    </sc.TypeWrapper>
  );
};

VerificationDocument.propTypes = {
  documentId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  status: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  details: PropTypes.array,
  showUpload: PropTypes.bool,
  fileSelector: PropTypes.shape({
    enabled: PropTypes.bool,
    handleSelectedFile: PropTypes.func
  }),
  showEdit: PropTypes.bool,
  showView: PropTypes.bool,
  uploadFunction: PropTypes.func,
  editFunction: PropTypes.func,
  viewFunction: PropTypes.func,
  wholeDocClick: PropTypes.func,
  buttonText: PropTypes.string,
  isLoading: PropTypes.bool,
  isPointerDisabled: PropTypes.bool,
  leftChildren: PropTypes.oneOfType([PropTypes.node, PropTypes.elementType])
};

VerificationDocument.defaultProps = {
  buttonText: null,
  documentId: null,
  fileSelector: {
    enabled: false,
    handleSelectedFile: null
  },
  subtitle: null,
  status: null,
  details: null,
  showUpload: false,
  showEdit: false,
  showView: false,
  isLoading: false,
  isPointerDisabled: false,
  leftChildren: null,
  uploadFunction: () => {},
  editFunction: () => {},
  viewFunction: () => {},
  wholeDocClick: () => {}
};

export default VerificationDocument;
